import { models } from "types/api/viewModels.ts";

export interface AdminSearchResult {
	name?: string | null;
	id?: string | null;
	type: string;
	email?: string | null;
	number?: string | null;
}

export function formatSearchResults(
	response: models["UserPermissionsAdminSearchViewModel"] | undefined
): AdminSearchResult[] {
	if (!response) return [];

	return Object.entries(response).flatMap(([key, arr]) => {
		if (!Array.isArray(arr)) return [];

		return arr
			.filter((i) => i !== null)
			.map((item: models["UserViewModel"] | models["BillToViewModel"] | models["CustomerAccountViewModel"]) => {
				let name: string | null = null;
				let id: string | null = null;
				let email: string | null = null;
				let number: string | null = null;
				let type: string = "";

				if (key.toLowerCase().includes("user")) {
					const user = item as models["UserViewModel"];
					name = [user.firstName, user.lastName].filter(Boolean).join(" ");
					id = user.userId ?? null;
					email = user.email ?? null;
					number = null;
					type = "Person";
				} else if (key.toLowerCase().includes("account")) {
					const account = item as models["CustomerAccountViewModel"];
					name = account.accountName ?? null;
					id = account.accountId ?? null;
					email = null;
					number = account.accountNumber ?? null;
					type = "Account";
				} else if (key.toLowerCase().includes("bill")) {
					const billTo = item as models["BillToViewModel"];
					const billToCityState = [billTo.city, billTo.state].filter(Boolean).join(", ");
					name = [billTo.projectName, billToCityState].filter(Boolean).join(" - ") ?? null;
					id = billTo.accountId ?? null;
					email = null;
					number = billTo.billToId ?? null;
					type = "Bill To";
				}

				return {
					name,
					id,
					email,
					number,
					type
				};
			});
	});
}
